import { useEffect, useState, useRef, RefObject } from 'react';
import { FaCaretRight } from 'react-icons/fa';
import Form from '../../Form';
import {
  Wrapper,
  Title,
  ProgressWrapper,
  Progress,
  ProgressArrow,
  Desc,
  FormWrapper,
  Button,
  ButtonWrapper,
  AuthInfo,
  AuthInfoHeader,
  AuthInfoValue,
} from "./style"

const Input = () => {
  return (
    <Wrapper>
      <Title>
        M・E・Mの節電チャレンジ参加申込みが完了いたしました。
        <br/>
        ご参加ありがとうございます。
        <br/>
        節電へご協力お願いします。
      </Title>
    </Wrapper>
  )
}
export default Input;
